// ID-035: opens a request file through the authenticated API (server enforces owner/admin access) — preview images, download others.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Sample photo thumbnail loaded through the authenticated API; click opens the same preview.
export const SampleImage = ({ path, a }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let obj;
    api.get(path, { responseType: "blob" }).then((r) => { obj = URL.createObjectURL(r.data); setSrc(obj); }).catch(() => {});
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [path]);
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`custom-sample-image-${a.idx}`}>
        {src ? <img src={src} alt={a.filename} className="h-28 w-28 rounded-md border border-border object-cover" /> : <span className="block h-28 w-28 rounded-md border border-border bg-sand" />}
      </button>
      <Dialog open={open && !!src} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl bg-white" data-testid={`custom-sample-image-${a.idx}-preview`}>
          <DialogHeader><DialogTitle className="truncate text-base">{a.filename}</DialogTitle></DialogHeader>
          <img src={src} alt={a.filename} className="max-h-[70vh] w-full object-contain" />
        </DialogContent>
      </Dialog>
    </>
  );
};

export const AttachmentLink = ({ path, filename, testid, className }) => {
  const [url, setUrl] = useState(null);
  const open = async () => {
    try {
      const r = await api.get(path, { responseType: "blob" });
      const obj = URL.createObjectURL(r.data);
      if ((r.data.type || "").startsWith("image/")) { setUrl(obj); return; }
      const a = document.createElement("a");
      a.href = obj; a.download = filename; a.click();
      setTimeout(() => URL.revokeObjectURL(obj), 10000);
    } catch (e) {
      toast.error(e.response?.status === 404 ? "File not found" : "You don't have access to this file");
    }
  };
  const close = () => { URL.revokeObjectURL(url); setUrl(null); };
  return (
    <>
      <button type="button" onClick={open} className={className} data-testid={testid}>{filename}</button>
      <Dialog open={!!url} onOpenChange={(o) => { if (!o) close(); }}>
        <DialogContent className="max-w-3xl bg-white" data-testid={`${testid}-preview`}>
          <DialogHeader><DialogTitle className="truncate text-base">{filename}</DialogTitle></DialogHeader>
          {url && <img src={url} alt={filename} className="max-h-[70vh] w-full object-contain" />}
          {url && <a href={url} download={filename} className="text-xs font-medium text-terracotta underline" data-testid={`${testid}-download`}>Download</a>}
        </DialogContent>
      </Dialog>
    </>
  );
};
